import { IEvent, IEventScoreBoard, IEventScoreBoardResult, IScoreType } from "bets.oddprovider.lib.common.ts/models"
import { ApiClientUtils } from "fwork-jsts-common/src/apiClient"
import { FormItemStyled, FormStyled } from "fwork.react.apptemplate"
import { useSnackbar } from "notistack"
import React, { useEffect, useState } from "react"
import axios from "../../../apiClient/axios"
import { ScoreTypesApiClient } from "../../../apiClient/scoreTypes"
import { DEFAULTGAP } from "../../../globals"
import { AccordionItem } from "./accordion/accordion"
import { EventScoreBoardComponent } from "./eventScoreBoard"

export interface EventScoreBoardsComponentProps extends React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement> {
  event: IEvent
  onChangeResult?: (eventScoreBoard: IEventScoreBoard, result: IEventScoreBoardResult) => void
}

export const EventScoreBoardsComponent = (props: EventScoreBoardsComponentProps) => {
  const { event, onChangeResult, ...rest } = props

  const { enqueueSnackbar } = useSnackbar()
  const [loadingScoreTypes, setLoadingScoreTypes] = useState<boolean>()
  const [scoreTypes, setScoreTypes] = useState<IScoreType[]>()

  const [expandedIds, setExpandedIds] = useState<Set<string>>(new Set())

  useEffect(() => {
    if (scoreTypes) {
      const newExpanded = new Set(expandedIds)

      scoreTypes.forEach(score => {
        const shouldBeExpanded = score.always_show ||
          event?.score_board?.some(s => s.score_type_id === score.id)

        if (shouldBeExpanded) {
          newExpanded.add(score.id.toString())
        } else {
          newExpanded.delete(score.id.toString())
        }
      })

      setExpandedIds(newExpanded)
    }
  }, [event?.score_board, scoreTypes])

  const toggleAccordion = (id: string) => {
    setExpandedIds(prev => {
      const newSet = new Set(prev)
      if (newSet.has(id)) {
        newSet.delete(id)
      } else {
        newSet.add(id)
      }
      return newSet
    })
  }

  useEffect(() => {
    (async () => {
      await getScoreTypes()
    })()
  }, [])

  const getScoreTypes = async () => {
    if (loadingScoreTypes) return
    setLoadingScoreTypes(true)

    try {
      const response = await new ScoreTypesApiClient(axios).get({
        where: {
          sport_id: event.sport_id
        },
        sort: { name: 1 }
      })
      setScoreTypes(response.data?.payload)

      return scoreTypes
    } catch (error) {
      enqueueSnackbar(ApiClientUtils.getErrorMessage(error), { variant: 'error' })
    } finally {
      setLoadingScoreTypes(false)
    }
  }

  return <div {...rest} aria-label="EventScoreBoardsComponent">
    <FormStyled gap={DEFAULTGAP} fullWidth style={{
      width: '100%',
      background: '#F9F9F9'
    }}>
      {scoreTypes?.map((score, idx) => {
        const isExpanded = expandedIds.has(score.id.toString())

        return (
          <FormItemStyled key={score.id} fullWidth gap={DEFAULTGAP} style={{ /* ... */ }}>
            <AccordionItem
              expanded={isExpanded}
              onToggle={() => toggleAccordion(score.id.toString())}
              title={score.name}
            >
              <EventScoreBoardComponent
                key={score.id}
                onChangeResult={onChangeResult}
                eventScoreBoard={event?.score_board?.filter(s => s.score_type_id == score.id)[0] ?? {
                  id: 0,
                  score_type_id: score.id,
                  name: score.name,
                  result: event?.participants?.map((p, idx) => ({ position: idx + 1 } as IEventScoreBoardResult)) ?? [],
                } as IEventScoreBoard}
                event={event}
              />
            </AccordionItem>
          </FormItemStyled>
        );
      })}
    </FormStyled>
  </div>
}